<template>
    <div div id="details" class="wrapper-group-itens b-container">
         <div class="d-flex justify-content-between flex-column content">
           <div v-for="(itemEquipment, index)  in equipmentsDTO" :key="index" class="selected column">
             <h5> {{ itemEquipment.title }}</h5>
             <div class="selected-box">
              <div v-if="!details[itemEquipment.key].length">
             {{ `${itemEquipment.noDataMessage}  ${details.NAME}.`}}
              </div>
              <div
                class="selected-item"
                v-for="subItemEquip in details[itemEquipment.key]"
                :key="subItemEquip.ID"
              > 
              {{ subItemEquip.NAME }}
              </div> 
            </div>
             
           </div>
           <!-- <div class="selected">
             <h5>Agendas</h5>
             <div class="selected-box">
               <div v-if="!details.AGN.length">
                 Não há agendas cadastradas no setor {{ details.NAME }}.
               </div>
               <div
                 class="selected-item"
                 v-for="agn in details.AGN"
                 :key="agn.ID"
               > 
               {{ agn.NAME }}
               </div> 
             </div>
 
           </div>
           <div class="selected">
             <h5>Bombas</h5>
             <div class="selected-box">
               <div v-if="!details.PUMP.length">
                 Não há bombas cadastradas no setor {{ details.NAME }}.
               </div>
               <div
                 class="selected-item"
                 v-for="pump in details.PUMP"
                 :key="pump.ID"
               >
                 {{ pump.NAME }}
               </div>
             </div>
           </div>
           <div class="selected">
             <h5>Válvulas</h5>
             <div class="selected-box">
               <div v-if="!details.VALVE.length">
                 Não há válvulas cadastradas no setor {{ details.NAME }}.
               </div>
               <div
                 class="selected-item"
                 v-for="valve in details.VALVE"
                 :key="valve.ID"
               >
                 {{ valve.NAME }}
               </div>
             </div>
           </div>
           <div class="selected">
             <h5>Hidrômetros</h5>
             <div class="selected-box">
               <div v-if="!details.HYDRO.length">
                 Não há hidrômetros cadastrados no setor {{ details.NAME }}.
               </div>
               <div
                 class="selected-item"
                 v-for="hydro in details.HYDRO"
                 :key="hydro.ID"
               >
                 {{ hydro.NAME }}
               </div>
             </div>
           </div>
           <div class="selected">
             <h5>Sensores</h5>
             <div class="selected-box">
               <div v-if="!details.SENSOR.length">
                 Não há sensores cadastrados no setor {{ details.NAME }}.
               </div>
               <div
                 class="selected-item"
                 v-for="sensor in details.SENSOR"
                 :key="sensor.ID"
               >
                 {{ sensor.NAME }}
               </div>
             </div>
           </div>
           <div class="selected">
             <h5>Usuários</h5>
             <div class="selected-box">
               <div v-if="!details.USERS.length">
                 Não há usuários cadastrados no setor {{ details.NAME }}.
               </div>
               <div
                 class="selected-item"
                 v-for="user in details.USERS"
                 :key="user.ID"
               >
                 {{ user.NAME }}
               </div>
             </div>
           </div> -->
         <!-- </div> -->
       </div> 
    </div>
 </template>
<script>
    export default {
        name: "modalEquipaments",
        props:{
            equipmentsDTO: {
                type : Array,
                required: true,
            },
            details: {
                type : Object,
                required: false,
            }

        },
    }
    
</script>
<style scoped>
  .wrapper-group-itens {
    position: inherit !important;
    box-shadow: none !important;
    width: 100% !important;
    margin:0 !important;
    padding: 0 !important;

  }

  .wrapper-group-itens > .content {
    margin: auto;
    width: 100% !important;
  }
  #details{
    max-height: auto;
  }
  #details .selected-box{
    height: 5em; 
    max-height :fit-content !important;
  }
  .selected{
    width: 100% !important;
  }
</style>
